import { AutocompleteInput } from "react-admin";
import BeforeAutocompleteInput from "./BeforeAutocompleteInput";
import DisableHandleKeyDown from "./DisableHandleKeyDown";

const CustomOption = ({ record }: { record?: any }) => {
  if (!record) return null;

  const isSubItem = record.name.startsWith("------");
  return (
    <div
      style={{
        paddingLeft: isSubItem ? "20px" : "0px",
        color: isSubItem ? "#666" : "#000",
      }}
    >
      {isSubItem ? record.name.replace("------", "") : record.name}
    </div>
  );
};
const getDisplayText = (choice: any) => {
  if (!choice) return "";
  const isSubItem = choice.name.startsWith("------");
  return isSubItem ? choice.name.replace("------", "") : choice.name;
};
const optionText = (choice: any) => <CustomOption record={choice} />;

const FilterCustomSelect = (props: any) => {
  const before = props?.before;
  const handleChange = (value: any) => {
    props?.onChange?.(value);
  };

  if (before == "and") {
    return (
      <>
        <BeforeAutocompleteInput
          label={props?.label}
          optionText={optionText}
          inputText={getDisplayText}
          variant="outlined"
          name={props?.source}
          choices={props?.optionlist}
          onChange={handleChange}
          onKeyDown={(e: any) => {
            DisableHandleKeyDown(e);
          }}
        />
      </>
    );
  } else {
    return (
      <>
        <AutocompleteInput
          label={props?.label}
          optionText={optionText}
          inputText={getDisplayText}
          variant="outlined"
          name={props?.source}
          choices={props?.optionlist}
          onChange={handleChange}
          onKeyDown={(e: any) => {
            DisableHandleKeyDown(e);
          }}
        />
      </>
    );
  }
};

export default FilterCustomSelect;
